"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _lodash = _interopRequireDefault(require("lodash"));
var _getSlimUser = require("../user/getSlimUser");
var _getSlimGroup = _interopRequireDefault(require("./getSlimGroup"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function eventCreatedAt() {
  return Math.floor(new Date().getTime() / 1000);
}
var EventTracker = exports["default"] = /*#__PURE__*/function () {
  function EventTracker() {
    _classCallCheck(this, EventTracker);
  }
  _createClass(EventTracker, null, [{
    key: "trackClick",
    value: function trackClick(eventName, payload, config) {
      var group = (0, _getSlimGroup["default"])(config);
      var user = (0, _getSlimUser.getSlimUser)(_lodash["default"].get(config, 'user', {}), group);
      var url = _lodash["default"].get(config, 'url', null);
      if (!url) {
        console.error('EventTracker.trackClick track url undefined.');
      }
      var data = {
        event: {
          name: eventName,
          created_at: eventCreatedAt()
        },
        payload: payload,
        user: user,
        group: group
      };
      function onSuccess() {
        return true;
      }
      function onError(error) {
        throw error;
      }
      var request = _axios["default"].post("".concat(url, "/events"), data);
      return request.then(onSuccess, onError);
    }
  }]);
  return EventTracker;
}();